const systemSettings = {
  pageName: 'Systemeinstellungen',
  templatePlaceholder: 'Vorlage auswählen',
  templateLabel: 'Vorlage für aktive Systemeinstellungen',
  templateDescriptions: 'Wähle eine Vorlage aus dem Dropdown-Menü oben aus. Die ausgewählte Vorlage wird angewendet, wenn du auf „Speichern“ tippst.',
  switchButton: {
    label: 'Sicht',
    options: {
      site: 'Bereich',
      account: 'Konto',
    },
  },
  toasts: {
    successfully: 'Erfolgreich gespeichert',
    error: 'Fehler',
  },
  toastReset: {
    successfully: 'Wiederherstellung auf Standardwerte erfolgreich abgeschlossen',
    error: 'Wiederherstellung auf Standardwerte fehlgeschlagen',
  },
  modalDelete: {
    header: 'Vorlage löschen',
    body: 'Sie sind dabei, eine Vorlage zu löschen?',
  },
  modalUnsaved: {
    header: 'Nicht gespeicherte Änderungen',
    body: 'Die vorgenommenen Änderungen wurden nicht gespeichert. Möchten Sie fortfahren, ohne sie zu speichern?',
  },
  modalResetSettings: {
    header: 'Standardwerte',
    body: 'Wenn Sie fortfahren, kehren Sie zu den Standardrollenberechtigungen zurück, was zum Verlust aller von Ihnen vorgenommenen Anpassungen führt.',
  },
  modalDeleteError: {
    header: 'Löschen einer automatisierungsfähigen Vorlage',
    body: 'Sie sind dabei, eine Vorlage zu löschen, die mit Automatisierungen verknüpft ist. Um mit dem Löschen fortzufahren, müssen Sie die Vorlage zunächst von den zugehörigen Automatisierungen trennen.',
  }
};

export default systemSettings;
